module.exports = __webpack_public_path__ + "img/picker_sel.1987b6a9.png";